import React from 'react'
import PropTypes from 'prop-types'

function Badge ({ content, dot, invisible, max = 99, children }) {
  const hidden = invisible || (!dot && !content) || content <= 0
  const displayContent = dot ? null : content >= max ? `${max}+` : content

  return (
    <span
      data-testid='badge-wrapper'
      aria-hidden={hidden || undefined}
      css={{
        position: 'relative',
        display: 'inline-flex',
        verticalAlign: 'middle',
        flexShrink: 0
      }}
    >
      <span
        data-testid='badge'
        css={{
          display: 'flex',
          flexFlow: 'row wrap',
          placeContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          top: 0,
          right: 0,
          padding: '0px 2px',
          fontWeight: 600,
          fontSize: '0.755rem',
          lineHeight: 1,
          background: '#ff6566',
          borderRadius: dot ? '50%' : 3,
          color: 'white',
          height: dot ? 7 : 14,
          minWidth: dot ? 7 : 14,
          transition: 'transform 200ms ease-out',
          transformOrigin: '100% 0%',
          transform: hidden ? 'scale(0)' : 'scale(1) translate(50%, -50%)'
        }}
      >
        {displayContent}
      </span>
      {children}
    </span>
  )
}

Badge.propTypes = {
  color: PropTypes.string,
  content: PropTypes.node
}

export { Badge }
